import { StyleSheet, Font } from "@react-pdf/renderer"
import { default as RobotoRegular } from "../fonts/Roboto/Roboto-Regular.ttf"
import { default as RobotoBold } from "../fonts/Roboto/Roboto-Bold.ttf"
import { default as RobotoItalic } from "../fonts/Roboto/Roboto-Italic.ttf"
import { default as RobotoMedium } from "../fonts/Roboto/Roboto-Medium.ttf"

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoRegular,
    },
    {
      src: RobotoBold,
      fontWeight: "bold",
    },
    {
      src: RobotoItalic,
      fontWeight: "normal",
      fontStyle: "italic",
    },
    {
      src: RobotoMedium,
      fontWeight: "medium",
      fontStyle: "normal",
    },
  ],
})

export const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFF",
    marginHorizontal: 50,
    marginTop: 30,
    paddingTop: 20,
    paddingBottom: 50,
    fontSize: "10pt",
    fontFamily: "Roboto",
  },
  view: {
    maxWidth: "75vw",
  },
  text: {
    lineHeight: "20pt",
    letterSpacing: "0.1pt",
  },
  paragraph: {
    marginBottom: 15,
    lineHeight: 1.5,
  },
  heading: {
    marginBottom: 3,
  },
  h1: {
    fontSize: "21pt",
    fontWeight: "bold",
    marginBottom: 20,
  },
  h2: {
    fontSize: "18pt",
    fontWeight: "bold",
    marginTop: 20,
  },
  h3: {
    fontSize: "15pt",
    fontWeight: "medium",
    marginTop: 10,
  },
  h4: {
    fontSize: "12pt",
    textDecorationStyle: "uppercase",
  },
  h5: {
    fontSize: "10pt",
    fontWeight: "bold",
    textDecorationStyle: "uppercase",
  },
  link: {
    textDecoration: "none",
  },
  list: {
    marginBottom: 10,
  },
  listItem: {
    marginVertical: 3,
  },
  strong: {
    fontWeight: "bold",
  },
  em: {
    fontStyle: "italic",
  },
  table: {
    border: 0,
  },
  tableHeader: {
    border: 0,
  },
  tableBody: {
    border: 0,
  },
  tableCell: {
    fontSize: "9pt",
    border: 0,
    paddingHorizontal: "3pt",
    paddingVertical: "8px",
  },
})
